import React, { useEffect, useState } from 'react';
import { companyAdminAPI } from '../../lib/walletApi';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Loader2, FileSpreadsheet, ArrowLeftRight, Heart } from 'lucide-react';

export default function CompanyReports() {
  const [payroll, setPayroll] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [benefits, setBenefits] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try { const [p, t, b] = await Promise.all([companyAdminAPI.getPayrollReport({}), companyAdminAPI.getTransactionReport({}), companyAdminAPI.getBenefitReport()]); setPayroll(p); setTransactions(t); setBenefits(b); }
      catch (e) { console.error(e); } finally { setLoading(false); }
    }; load();
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;

  return (
    <div className="space-y-6" data-testid="ca-reports">
      <div><h1 className="text-xl font-bold text-gray-900">Company Reports</h1><p className="text-sm text-gray-500">Payroll, transactions and benefit analytics</p></div>
      <Card className="border-gray-200 shadow-sm">
        <CardHeader className="pb-2"><CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2"><FileSpreadsheet className="w-4 h-4 text-pink-500" /> Payroll</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {[{ l: 'Runs', v: payroll?.total_runs || 0 }, { l: 'Gross', v: `NGN ${Number(payroll?.total_gross || 0).toLocaleString()}` }, { l: 'Net', v: `NGN ${Number(payroll?.total_net || 0).toLocaleString()}` }, { l: 'Deductions', v: `NGN ${Number(payroll?.total_deductions || 0).toLocaleString()}` }, { l: 'Benefits', v: `NGN ${Number(payroll?.total_benefits || 0).toLocaleString()}` }, { l: 'Paid', v: payroll?.total_employees_paid || 0 }].map(s => (
              <div key={s.l} className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">{s.l}</p><p className="text-sm font-bold text-gray-900">{s.v}</p></div>
            ))}
          </div>
        </CardContent>
      </Card>
      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="border-gray-200 shadow-sm">
          <CardHeader className="pb-2"><CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2"><ArrowLeftRight className="w-4 h-4 text-emerald-500" /> Transactions</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Total</p><p className="text-sm font-bold text-gray-900">{transactions?.total_transactions || 0}</p></div>
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Volume</p><p className="text-sm font-bold text-gray-900">NGN {Number(transactions?.total_volume || 0).toLocaleString()}</p></div>
            </div>
          </CardContent>
        </Card>
        <Card className="border-gray-200 shadow-sm">
          <CardHeader className="pb-2"><CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2"><Heart className="w-4 h-4 text-pink-500" /> Benefits</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Elections</p><p className="text-sm font-bold text-gray-900">{benefits?.total_elections || 0}</p></div>
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Active</p><p className="text-sm font-bold text-gray-900">{benefits?.active_elections || 0}</p></div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
